import { render, staticRenderFns } from "./UserProfileStatus.vue?vue&type=template&id=09b21f46&scoped=true&"
import script from "./UserProfileStatus.vue?vue&type=script&lang=js&"
export * from "./UserProfileStatus.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileStatus.vue?vue&type=style&index=0&id=09b21f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b21f46",
  null
  
)

export default component.exports